import { render, staticRenderFns } from "./WfConsumerUserForm.vue?vue&type=template&id=67dd6844&"
import script from "./WfConsumerUserForm.vue?vue&type=script&lang=js&"
export * from "./WfConsumerUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports